const scene = "plan";
export const UPDATE_PLAN_SERVICE = `${scene}UPDATE_PLAN_SERVICE`;
export const UPDATE_CUSTOM_PLAN = `${scene}UPDATE_CUSTOM_PLAN`;
export const UPDATE_BUNDLE_GROUP_PLAN = `${scene}UPDATE_BUNDLE_GROUP_PLAN`;
export const UPDATE_BUNDLE_PLAN_SERVICE = `${scene}UPDATE_BUNDLE_PLAN_SERVICE`;
export const UPDATE_TEST_PREFERENCE = `${scene}UPDATE_TEST_PREFERENCE`;
export const UPDATE_TEST_CENTER_DETAILS = `${scene}UPDATE_TEST_CENTER_DETAILS`;

